import { take, fork } from 'redux-saga/effects';
import { USER_AMEND_LOAD_REQUESTED } from '../actions/userInfo';
import editUserInfo from './editUserInfo';

export default function* () {
  while (true) {
    const action = yield take(USER_AMEND_LOAD_REQUESTED);
    yield fork(editUserInfo, action);
  }
}
